import React, { Component,Fragment } from 'react';
import Select from 'react-select';
import './ReactSelector.css';



export default class ReactSelector extends Component {

  constructor(props){
    super(props);
    this.state={choices:this.props.aniElo,selectedValue:this.props.aniElo[0]};
  }

  componentDidMount(){
    this.setState({choices:this.props.aniElo});
  }

  componentWillReceiveProps({aniElo}){
    // this.state={choices:aniElo};
    this.setState({choices:aniElo});
    
    // Choices=this.state.choices;
    // //Choices=this.state.aniElo;
  }

  componentDidUpdate(){
    //Choices=this.state.aniElo;
  }


  change=(choice)=>{
    this.setState({selectedValue:{label:choice.label,value:choice.value}},this.props.filtrezhotarari(choice.value));
  }

  // changetip=(tip)=>{
  //   tip.value===1?Choices=ChoicesAvere:Choices=ChoicesInterese;
  //   let choice=Choices.find(o => o.label === this.state.selectedValue.label);
  //   this.setState({selectedTip:{label:tip.label,value:tip.value}},this.props.incarcDeclaratii(choice.value));
  // }




  render() {
    return (
      <Fragment>
      <div className="row">
            <div className="col-md-3 dropdownselect dropdownani">
              <Select options={this.props.aniElo} onChange={this.change} value={this.state.selectedValue} />
            </div>
      </div>
        </Fragment>
    )
  }
}
